import { META_HTML_TITLE, META_ALLOW_ANONYMOUS } from "@core/constants";
import { ETAB_ROUTES } from "@etab/config";
import { DataLayerManager } from "@core/managers/datalayer-manager";
import { StorageManager } from "@core/managers/storage.manager";

import AccountRoot from "./Account.root.vue";
import CguPage from "./Cgu.page.vue";
import ConfidentialityPage from "./Confidentiality.page.vue";
import OnboardingPage from "./Onboarding.slides.vue";
import AccountInformationsPage from "./AccountInformations.page.vue";
import AdminFolderPage from "./AdminFolder.page.vue";
import AdminFolderStatusPage from "./AdminFolderStatus.page.vue";
import MultiAccountPage from "./MultiAccount.page.vue";
import getProfilePages from "./profile";
import DeveloperPage from "./Developer.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.account.root.path,
      name: ETAB_ROUTES.account.root.name,
      component: AccountRoot,
      meta: { [META_HTML_TITLE]: "ETAB.PAGES.ACCOUNT.@TITLE" },
      children: [
        {
          path: ETAB_ROUTES.account.cgu.path,
          name: ETAB_ROUTES.account.cgu.name,
          meta: { [META_ALLOW_ANONYMOUS]: true },
          component: CguPage,
        },
        {
          path: ETAB_ROUTES.account.confidentiality.path,
          name: ETAB_ROUTES.account.confidentiality.name,
          meta: { [META_ALLOW_ANONYMOUS]: true },
          component: ConfidentialityPage,
        },
        {
          path: ETAB_ROUTES.account.accountInformations.path,
          name: ETAB_ROUTES.account.accountInformations.name,
          component: AccountInformationsPage,
        },
        {
          path: ETAB_ROUTES.account.adminFolder.path,
          name: ETAB_ROUTES.account.adminFolder.name,
          component: AdminFolderPage,
        },
        {
          path: ETAB_ROUTES.account.adminFolderStatus.path,
          name: ETAB_ROUTES.account.adminFolderStatus.name,
          component: AdminFolderStatusPage,
        },
        {
          path: ETAB_ROUTES.account.multiAccount.path,
          name: ETAB_ROUTES.account.multiAccount.name,
          component: MultiAccountPage,
        },
        {
          path: ETAB_ROUTES.account.onboarding.path,
          name: ETAB_ROUTES.account.onboarding.name,
          component: OnboardingPage,
          meta: { [META_ALLOW_ANONYMOUS]: true },
          async beforeEnter(to, from, next) {
            DataLayerManager.setData(
              { page_type: "formulaire", user_connect: "no", formulaire: "creation_annonce" },
              "etablissement",
              StorageManager.getUserInfo("etablissement"),
            );
            next();
          },
        },
        {
          path: ETAB_ROUTES.account.developer.path,
          name: ETAB_ROUTES.account.developer.name,
          component: DeveloperPage,
        },
        ...getProfilePages(),
      ],
    },
  ];
}
